import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { adminSearchIngredients } from '@api/adminIngredients';
import { IAdminIngredientsSearchResult } from '@interfaces/adminIngredients';
import { IFetchListRequestProps } from '@interfaces/common';

import { buildAdminSearchIngredientsPayload } from './utils';

export const handleGetAdminIngredientsSearch = createAsyncThunk<
  AxiosResponse<IAdminIngredientsSearchResult>,
  IFetchListRequestProps
>('getAdminIngredientsSearch', props =>
  adminSearchIngredients(buildAdminSearchIngredientsPayload(props)),
);
